import React from 'react';
import { Col } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';

const AvailabilityHeading = (props) => {

    const { screen, text } = props;
    const { screenHeading } = constantStyles;

    return (
        <Col style={screenHeading}>
            <label>
                <MaterialIcon icon={text ? 'description': "access_time"} color="#000" size={20} />&nbsp;
                    {text ? text : i18n.t(`screens:${screen}Screen.${screen}Available`)}
            </label>
        </Col>
    );
}

export default AvailabilityHeading;

const constantStyles = {
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: -5,
        paddingLeft: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/availability/AvailabilityHeading.js